import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import { DisplayDecision } from 'game/display/DisplayDecision';
import { FONT_BASE } from 'game/constants/AppFonts';

export class ScenarioDecision extends SceneBase {
  constructor() {
    super({ key: KEYS.ScenarioDecision, active: false });
  }
  create() {
    super.create();
    this.setBackgroundColour(0x0069b5);
    this.bg = this.add.image(0, 0, 'backgrounds', 'background_home').setOrigin(0);

    this.game.hud.setState('GAME');

    this._displayDecision = new DisplayDecision(this);

    this.topLine = this.add.rectangle(840, 140, 800, 2, 0xffffff).setOrigin(0.5, 0);
    this.bottomLine = this.add
      .rectangle(840, this.game.defaultHeight - 100, 800, 2, 0xffffff)
      .setOrigin(0.5, 1);

    this.add
      .text(
        this.topLine.x - this.topLine.width / 2,
        this.topLine.y - 10,
        this.game._scenario.getCurrentScenarioTitle,
        {
          fontFamily: FONT_BASE.CALIBRE_BOLD,
          fontSize: '64px',
          color: '#ffffff',
        }
      )
      .setOrigin(0, 1);

    this.game.hud.events.on(
      'CLOSE_SCORES_MODAL',
      () => {
        this.game.hud.setState('GAME');
      },
      this
    );
  }

  shutdown() {
    this.game.hud.events.off(
      'CLOSE_SCORES_MODAL',
      () => {
        this.game.hud.setState('GAME');
      },
      this
    );
    this._displayDecision.shutdown();
    super.shutdown();
  }
}
